export default "/Frontend/dist/xls.7d6837b37efcee8f4d7cb4af5c6f6b09.svg";